import React from "react"
import { Box, useTheme } from "@mui/material"
import CameraButton from "./filtersInMap/cameraButton"
import SelectAreas from "../../FilterDispatchHotMap/components/selectAreas"

interface FiltersInMapProps {
  readonly position?: 'bottomleft' | 'bottomright' | 'topleft' | 'topright'
}

const POSITION_CLASSES = {
  bottomleft: 'leaflet-bottom leaflet-left',
  bottomright: 'leaflet-bottom leaflet-right',
  topleft: 'leaflet-top leaflet-left',
  topright: 'leaflet-top leaflet-right',
}

export default function FiltersInMap({ position = 'topright' }: FiltersInMapProps) {
  const positionClass = POSITION_CLASSES[position]
  const theme = useTheme()

  return (
    <div className={positionClass} style={{ width: '50%' }}>
      <div
        className="leaflet-control leaflet-bar"
        style={{
          width: '50%',
          display: "flex",
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
          gap: '16px',
          border: 'none',
        }}>
        <div
          className="locality-control-container"
          style={{ 
            background: theme.palette.background.paper,
            width: '50%' 
          }}>
          <SelectAreas />
        </div>
        <div
          className="locality-control-container"
          style={{
            background: theme.palette.background.paper,
          }}>
          <CameraButton />
        </div>
      </div>
    </div>
  )
}